// Kept separate so i18n.ts can hot-swap translations without re-running init
// Lazy: each language/namespace file is its own chunk, fetched on first use
const featureTranslations = import.meta.glob('../../../libs/main/*/src/translations/*/*.json', { query: '?raw', import: 'default' });
const appTranslations = import.meta.glob('./translations/*/*.json', { query: '?raw', import: 'default' });
const uiTranslations = import.meta.glob('../../../libs/shared/ui/src/translations/*/*.json', { query: '?raw', import: 'default' });
const memberAssignmentTranslations = import.meta.glob('../../../libs/shared/member-assignment/src/translations/*/*.json', {
  query: '?raw',
  import: 'default',
});
const commonTranslations = import.meta.glob('../../../libs/shared/i18n/src/translations/*/*.json', { query: '?raw', import: 'default' });
const commentsTranslations = import.meta.glob('../../../libs/shared/comments/src/translations/*/*.json', {
  query: '?raw',
  import: 'default',
});

const allTranslations = {
  ...featureTranslations,
  ...appTranslations,
  ...uiTranslations,
  ...memberAssignmentTranslations,
  ...commentsTranslations,
  ...commonTranslations,
} as Record<string, () => Promise<string>>;

export default allTranslations;
